<template>
  <div class="FooterList">
    <div class="FooterList-info">
      「プリクラON」公式サイトは、株式会社セガが運営しております。
      本サイトで使用されている画像、文章、情報、音声、動画等は株式会社セガの著作権により保護されております。
    </div>
    <div class="FooterList-webAccessibility" @click="onWebAccessibility">
      <span>ウェブアクセシビリティ方針</span>
    </div>
    <div class="FooterList-copylight">©SEGA</div>
  </div>
</template>

<script>
export default {
  name: 'FooterList',
  components: {
  },
  props: {
  },
  computed: {
  },
  methods: {
    onTwitter() {
      window.open(process.env.VUE_APP_SEGA_TWITTER_URL)
    },
    onLine() {
      window.open(process.env.VUE_APP_SEGA_LINE_URL)
    },
    onInstagram() {
      window.open(process.env.VUE_APP_SEGA_INSTAGRAM_URL)
    },
    onWebAccessibility(){
      window.open('https://www.sega.co.jp/web-accessibility/')
    }
  }
}
</script>

<style lang="scss" scoped>
.FooterList {
  height: 270px;
  background-color: #CFCBCB;
  overflow: hidden;
  margin: 60px 0 55px;
  &-info,
  &-webAccessibility,
  &-copylight {
    color: #4B4344;
    font-size: 11px;
  }
  &-info {
    margin: 60px 30px 0;
  }
  &-webAccessibility {
    width: fit-content;
    margin: 30px;
    text-decoration: underline;
    cursor: pointer;
  }
  &-copylight {
    margin: 30px;
  }
}
</style>

